const InstitutionalPresentation = () => {
  window.location.href = 'https://prezi.com/view/QDaUZDIYhL48Snw3l0S8/';
  return null;
};

export default InstitutionalPresentation;
